<template>
  <header class="header-bg" :class="{'white-header':type}">
    <div class="other-header-container">
      <div class="other-header-container-inner">
        <div class="top">
          <img v-if="!type" src="@/assets/img/index/logo-text-green.png" alt="">
          <div class="header-nav">
            <LayoutHeaderNav :type="type"/>
          </div>
          <search-bar style="margin-left: auto" :type="type"/>
          <LayoutHeaderUser :type="type"/>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import LayoutHeaderNav from "@components/layout/header/LayoutHeaderNav.vue";
import SearchBar from "@components/layout/header/SearchBar.vue";
import LayoutHeaderUser from "@components/layout/header/LayoutHeaderUser.vue";

export default {
  name: "IndexHeaderNav",
  components: {LayoutHeaderUser, SearchBar, LayoutHeaderNav},
  props: {
    type: {
      type:Boolean,
      default:false
    },
  },
}
</script>

<style scoped lang="less">

.white-header {
  background-color: transparent !important;
  color: #FFFFFF;

  .nav-container {
    color: #fff;
  }
}

.header-bg {
  width: 100%;
  height: 80px;
  background: #fff;

  > div {
    width: 1160px;
    margin: 0 auto;


  }

  > div {
    width: 1160px;

  }
}


.other-header-container-inner {
  margin: 0 auto;
  position: relative;
  width: 1160px;

  .top {
    height: 80px;
    display: flex;
    align-items: center;

    img {
      width: 132px;
    }
  }

  .header-nav {
    margin-right: 30px;
    margin-left: 40px;
  }

  .ant-input-group-wrapper {
  }

}
</style>
